module.exports = __webpack_public_path__ + "media/images/placeholders/gruppenprogramm-d44966b3911222e1dbf3dcae5c7b9f2e.jpg";